<template>
  <div class="top-filter-or-block">
    <div class="block">

      <div class="arg" v-for="(arg, argId) in expression.args">
        <div class="orLine" v-if="argId > 0">{{ i18n().orLine }}</div>
        <div class="orRow">
          <div class="expr">
            <TopFilterLogicBlock :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                               :parent="definition" @delete="deleteArg(argId)"></TopFilterLogicBlock>
          </div>
          <div class="buttons">
            <button v-if="parent" class="mdl-button delete-button" v-on:click="deleteArg(argId)">
              <i class="material-icons">delete_forever</i>
            </button>
            <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg">
              <!--<i class="material-icons">add</i>--> {{ i18n().or }}
            </button>
            <button class="mdl-button add-button" v-if="definition.isList && argId+1 == expression.args.length" v-on:click="addOuterAnd">
              <!--<i class="material-icons">add</i>--> {{ i18n().and }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"
import TopFilterLogicBlock from "./TopFilterLogicBlock"
import i18n from "i18n"

import api from "../../api"
import overlayModel from "../utils/overlayModel.js"
import PremiumOverlay from "../premium/PremiumOverlay.vue"

export default {
  name: 'top-filter-or-block',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  components: {
    TopFilterLogicBlock
  },
  data () {
    return {
    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    },
    premium() {
      return api.session.premium
    }
  },
  watch: {
  },
  methods: {
    i18n() { return i18n().filter },
    showPremiumOverlay() {
      overlayModel.show({
        component: PremiumOverlay,
        props: {
        },
        on: {}
      })
    },
    operatorTitle(name) {
      for (let op of this.possibleOperators) {
        if (op.name == name) return op.title
      }
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg() {
      if(!this.premium) return this.showPremiumOverlay()
      var narg = expression.newArg(this.expression, this.columns)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      if (this.expression.args.length <= 1) {
        return this.deleteThis()
      }
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setType(ev) {
      let nType = ev.target.value
      var nDefinition = expression.operatorsByName.get(nType)
      console.log("SET TYPE", nType)
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse(JSON.stringify(this.expression))]
        })
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        })
      }
      /* else if ((this.definition.element != nDefinition.element)
        || (this.definition.left != nDefinition.left)
        || (this.definition.right != nDefinition.right)) {
        console.log("RESET ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: nDefinition.defaultArgs(this.columns)
        })
      }*/ else {
        console.log("HOLD ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: this.expression.args
        })
      }
    },
    deleteThis() {
      this.$emit('delete')
    },
    addOuterAnd() {
      if(!this.premium) return this.showPremiumOverlay()
      this.$emit('addAnd')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .block > button {
  }

  .block > button i {
  }
  .block > .delete-button {
  }

  .block > .arg > button {
  }

  .block > .arg > button i {
  }

  .orLine {
    line-height: 1em;
    font-size: 0.85em;
    position: relative;
    text-transform: uppercase;
  }

  .orRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .expr {
    flex-grow: 1;
  }
  .buttons {
    flex-grow: 0;
  }
  .buttons button {
    padding: 0px 6px;
    min-width: 1px;
  }

</style>



// WEBPACK FOOTER //
// TopFilterOrBlock.vue?57d82736